import { querySteps } from '@wix/ambassador-online-programs-v3-step/http';
import { DescriptionFieldSet } from '@wix/ambassador-online-programs-v3-step/types';
import _ from 'lodash';
import { extractImagesFromSteps } from './utils';
const PAGE_LIMIT = 100;
const QUERY_LIMIT = 250;
export const batchFetchOnlineProgramsSteps = async (httpClient, errorHandler, programIds) => {
  const programsIdsBatch = _.chunk(programIds, QUERY_LIMIT);
  const promiseArray = programsIdsBatch.map(batch => fetchOnlineProgramsSteps(httpClient, errorHandler, batch));
  const allSteps = [];
  const results = await Promise.allSettled(promiseArray);
  results.forEach(result => {
    if (result.status === 'fulfilled') {
      allSteps.push(...result.value);
    }
  });
  return extractImagesFromSteps(allSteps);
};
export const fetchOnlineProgramsSteps = async (httpClient, errorHandler, programIds) => {
  const {
    withErrorHandler
  } = errorHandler;
  const allSteps = [];
  let cursor;
  let hasMore = false;
  await withErrorHandler(async () => {
    do {
      var _pagingMetadata$curso;
      const {
        data: {
          steps,
          pagingMetadata
        }
      } = await httpClient.request(querySteps({
        descriptionFieldSet: DescriptionFieldSet.EXTENDED,
        query: {
          cursorPaging: {
            cursor,
            limit: PAGE_LIMIT
          },
          filter: cursor ? undefined : {
            programId: {
              $in: programIds
            }
          }
        }
      }));
      allSteps.push(...(steps ?? []));
      hasMore = (pagingMetadata == null ? void 0 : pagingMetadata.hasNext) ?? false;
      cursor = pagingMetadata == null || (_pagingMetadata$curso = pagingMetadata.cursors) == null ? void 0 : _pagingMetadata$curso.next;
    } while (hasMore);
    return allSteps;
  }, {
    errorCodesMap: {}
  });
  return allSteps;
};
//# sourceMappingURL=fetch-online-programs-steps.js.map